import { Component, Vue } from 'vue-property-decorator'

@Component
export default class ShowPassword extends Vue {
	pass_is_displayed: boolean = false;

	displayPassword() {
		this.pass_is_displayed = !this.pass_is_displayed
	}
}